<template>
<!-- 停车收费 -->
  <div class="parking">
      <div class="imgBox">
          <img class="bgImg" :src="require('@/assets/img/beijing.png')" alt="">
      </div>
      <div class="formBox" >
          <div class="item">
              <span>收款员编码</span>
              <input   v-model="queryInfo.deptId"  placeholder="请输入收款员编码"> 
          </div>
          <div class="item">
              <span>收款员名称</span>
              <input   v-model="queryInfo.roadName"  placeholder="请输入收款员名称"> 
          </div>

          <van-button
            block
            type="info"
            :disabled="(queryInfo.deptId && queryInfo.roadName)?false:true"
            class="btn"
            @click="getInitLogin"
         >确定</van-button>
      </div>
      <Foot v-if="list && list.bottomMessage && list.bottomMessage.length>0" :list="list"></Foot>
  </div>


</template>

<script>
import { Toast,Dialog } from 'vant';
import Head from "@/components/head";
import Foot from "@/components/foot";
// import {getIsApp} from '../../utils/common';

let loadedMineMapJs = false;
export default {
    components: {
        Head,
        Foot,
    },
    data() {
        return {
            showD:false,
            vde:'',
            isApp:'',
            list:[],
            queryInfo:{
                deptId:'',
                roadName:'',
                roadCode:'',
            },
        }
    },

    created() {
        this.vde = this.$route.query.vde?this.$route.query.vde:'';
        this.isApp = this.$route.query.isApp?this.$route.query.isApp:'';
        this.appParkingMsg = localStorage.getItem('appParkingMsg')?JSON.parse(localStorage.getItem('appParkingMsg')):'';
        if (this.appParkingMsg && this.appParkingMsg.deptId && this.appParkingMsg.isApp == '1') {
            this.queryInfo.deptId = this.appParkingMsg.deptId;
            this.queryInfo.isApp = this.appParkingMsg.isApp;
            this.queryInfo.roadCode = this.appParkingMsg.roadCode;
            this.queryInfo.roadName = this.appParkingMsg.roadName;
            this.toRoadSearch();
        }
        this.getHeadImg();
        this.getFootData();
    },
    methods:{
        closeO(){
            this.showD=false;
        },
        getHeadImg() {
            let data = {};
            data.vde = this.vde;
            this.request({
                url:'/webPortal/websitConfig',
                method:'get',
                params:data
            }).then((res)=>{
                if (res.data.code == 1000) {
                    sessionStorage.setItem("title", res.data.result.websitTitle);
                     document.title = sessionStorage.getItem('title');
                    } else if (res.data.code != 1000){
                   this.$router.push({ path: "/404" });
                }
            })
        },
        // 获取底部数据
        getFootData() {
            let data = {
                vde: this.vde,
                type: 10
            };
            this.request({
                url:'/systemManage/mobileGetMessage',
                method:'get',
                params:data
            }).then((res)=>{
                if (res.data.code == 1000) {
                this.list = res.data.result;
                }
            })
        },
        getInitLogin() {
           this.request({
               url:'/report/appRoadNameLogin',
               method:'get',
               params:{
                   deptId:this.queryInfo.deptId,
                   roadName:this.queryInfo.roadName,
               }
           }).then((res)=>{
               if (res.data.code == 1000) {
                   this.queryInfo.roadCode = res.data.message;
                   this.toRoadSearch();
               }else {
                   if(!res.data.errorMessage){
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    }).then(() => {});
                   }
               }
           })
        },
        toRoadSearch() {
            localStorage.setItem('appParkingMsg',JSON.stringify(
                {
                    deptId:this.queryInfo.deptId,
                    isApp:this.isApp,
                    roadCode:this.queryInfo.roadCode,
                    roadName:this.queryInfo.roadName
                }
                ));
            if (this.isApp == '1') {
                 let result = {
                    id:this.queryInfo.roadCode,
                    type_id:'',
                    sys_id:'5000000001'
                }
                window.android.bindService(JSON.stringify(result));
            }
            this.$router.push({path:'/parking/roadSummary?deptId=' + this.queryInfo.deptId+'&roadCode='+this.queryInfo.roadCode+'&roadName='+this.queryInfo.roadName+'&isApp='+this.isApp+'&vde='+this.vde})
        },

    }
}
</script>

<style scoped lang='scss'>
    .parking {
        // padding: 0 2vw;
        position: relative;
        background: #fff;
        height: 100vh;
       .btn {
           margin-top: 20px;
       }
       .imgBox {
           height: 400px;
       }
       .bgImg {
           width: 100%;
       }
       .formBox {
           width: 90%;
           border-radius: 5px;
           height: 240px;
           background-color: #fff;
           box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
           position: absolute;
           left: 50%;
           margin-left: -45%;
           top: 150px;
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 30px;
           .item {
               border-bottom: 1px solid #cccccc;
               height: 70px;
               padding-bottom: 10px;
               box-sizing: border-box;
               line-height: 70px;
               display: flex;
               align-items: center;
               span {
                   color: #333;
                   font-size: 16px;
                   width: 80px; 
                   white-space: nowrap;
               }
               input {
                   background: transparent;
                   margin-left: 20px;
                   font-size: 14px;
               }
               textarea {
                   width: 220px;
                   height: 70px;
                   line-height: 20px;
                   background: transparent;
                   margin-left: 20px;
                   font-size: 14px;
                   border: none;
                    position: relative;
                    top: 15px;
                    height: 49px;
               }
           }
           .van-button {
               background:#0052ee;
               border-radius: 5px;
           }
       }
    }
</style>